import { Component, OnInit } from '@angular/core';
import { SharedDataService } from '@teem/services/shared-data.service';
import { STORE_TYPE } from '@teem/core/constants/defaults';

@Component({
  selector: 'app-store-information',
  templateUrl: './store-information.component.html',
  styleUrls: ['./store-information.component.scss']
})

export class StoreInformationComponent implements OnInit {
  basicInfo: any;
  storeType: string = '';

  constructor(private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.userInfo) {
        this.basicInfo = data.userInfo;
        this.storeType = data.userInfo.store_type;
      }
    })
  }

  get isProductType() {
    return this.basicInfo && this.basicInfo?.store_type == STORE_TYPE.PRODUCT; //&& !this.basicInfo?.is_branch;
  }

  get isStoreType() {
    return this.basicInfo && this.basicInfo?.store_type == STORE_TYPE.SERVICE;
  }

  get isBranch() {
    return this.basicInfo && this.basicInfo?.is_branch && this.basicInfo?.store_type == STORE_TYPE.PRODUCT;
  }

  businessTypeChange(_businessStatus: String) {
    this.basicInfo.store_type = (STORE_TYPE.SERVICE == _businessStatus) ? STORE_TYPE.SERVICE : STORE_TYPE.PRODUCT;
    this.storeType = (STORE_TYPE.SERVICE == _businessStatus) ? STORE_TYPE.SERVICE : STORE_TYPE.PRODUCT;
    (window as any).userInfo.store_type = this.storeType;
  }

}

